<template>
    <b-container>
        <b-row style="margin-top:20px">
            <b-col>
                <h4>Please select the Type of beverage your are adding</h4>
            </b-col>
        </b-row>
        <!-- Main drink category -->
        <b-row>
            <b-col>
                <template v-for="cat in getDrinkCategories">
                    <b-button  :key="cat" class="m-md-2" variant="info" @click="setDrinkCategory(cat)">
                        {{cat}}
                    </b-button>
                </template>
            </b-col>
        </b-row>
        <hr>

        <!-- Display cat of drink -->
        <b-row>
            <b-col>
                <h5>{{beer.cat}}</h5>
            </b-col>
        </b-row>

        <!-- Display type of drink, only for beers and wines -->
        <b-row v-if="getThisDrinkType&&beer.cat=='Beers'">
            <b-col>
                <h4>Please select the Style of this Beer</h4>
            </b-col>
        </b-row>
        <b-row v-if="getThisDrinkType&&beer.cat=='Wines'">
            <b-col>
                <h4>Please select the Style of this Wine</h4>
            </b-col>
        </b-row>


        <b-row v-if="getThisDrinkType">
            <template  v-for="type in getThisDrinkType">
                <b-button  :key="type" class="m-md-2" variant="secondary" @click="setDrinkType(type)">
                    {{type}}
                </b-button>
            </template>
        </b-row>

        <!-- Other style -->
        <div  v-if="beer.type=='Other'">
            <b-col>
                <form>
                    <label for="customtype">Enter a custom style name</label>
                    <input v-model="beer.customType" type="text" id="customtype"/>
                </form>
            </b-col>
        </div>
        <!-- Modal to select more styles for beers -->
        <b-button v-if="beer.cat=='Beers'" variant="warning" v-b-modal.modalmorestyles>More Styles</b-button>
        <b-modal no-fade  scrollable size="xl" id= "modalmorestyles" title="More Styles" ok-only ok-variant="secondary" ok-title="Close" hide-footer>
            <div v-for="(category) in getFullBeerStylesList" :key="category.group">
                <h5>{{category.group}}</h5>
                <div v-for="(beer) in category.beers" :key="beer" style="cursor: pointer;"  @click="setOtherStyle(beer)">
                    {{beer}}
                </div>
                <hr>
            </div>
            <hr>
        </b-modal>

        <b-row>
            <b-col>
                <b-input-group prepend="(Optional) Sub Style" class="mt-3">
                    <b-form-input v-model="beer.subType"></b-form-input>
                    <b-input-group-append>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <!-- Display type of drink -->
        <b-row v-if="getThisDrinkType" style="margin-top:20px">
            <b-col>
                <h5>{{beer.type}} {{beer.subType}}</h5>
            </b-col>
        </b-row>
        <hr>

        <!-- Next -->
        <b-row>
            <b-col  style="margin-bottom:200px">
                <b-button :disabled="!enableNextButton" size="lg" class="m-md-2" variant="success" @click="goToDetails()">
                    Next
                </b-button>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
    import { mapState } from 'vuex'
    import { drinkCategories, mainBeerStylesList, wineCategories, fullBeerStylesList } from '../Myfunctions'
    export default {
        components: {
            },
        computed: {
            getDrinkCategories(){
                return drinkCategories
            },
            getMainBeerStylesList(){
                return mainBeerStylesList
            },
            getWineCategories(){
                return wineCategories
            },
            getFullBeerStylesList(){
                return fullBeerStylesList()
            },
            getThisDrinkType(){
                if(this.beer.cat=='Beers') return mainBeerStylesList
                if(this.beer.cat=='Wines') return wineCategories
                else return ""

            },
            enableNextButton(){
                if(!this.beer.cat) return false
                if((this.beer.cat=="Beers"||this.beer.cat=="Wines")&&!this.beer.type) return false
                else return true

            }
            
        },
        data() {
            return {
                beer:{
                    cat:'',
                    type:'',
                    subType:'',
                    customType:'',
                    
                }
            }
        },
        methods: {
            setDrinkCategory(category){
                this.beer.cat=category
                console.log("beer = ")
                console.log(this.beer)
            },
            setDrinkType(type){
                this.beer.type=type
                if(this.beer.customType) this.beer.type=this.beer.customType

            },
            setDrinkSubType(subType){
                this.beer.subType=subType

            },
            goToDetails(){
                if(this.beer.customType) this.beer.type=this.beer.customType
                this.$router.push({ name: 'drinkdetails', params: {theBeerFromType: this.beer }})

            },
            setOtherStyle(beerStyle){
                console.log(beerStyle)
                this.beer.type = beerStyle
                this.$root.$emit('bv::hide::modal',"modalmorestyles")
            }
            
        },
        
        
    }
</script>